<script>
  import { GQLNow } from "gql-now";
  import { onMount } from "svelte";
  import { BASE_URL } from "../services/service.config";
  import { PKClient } from "../services/PKClient";
  import {
    App,
    f7,
    f7ready,
    Card,
    CardFooter,
    CardContent,
    CardHeader,
    Page,
    Navbar,
    NavLeft,
    NavTitle,
    NavTitleLarge,
    NavRight,
    Link,
    Toolbar,
    Block,
    BlockTitle,
    List,
    ListItem,
    Row,
    Col,
    Button,
    Gauge,
    AreaChart,
    Panel,
    Menu,
    MenuItem,
    MenuDropdown,
    MenuDropdownItem,
    Icon,
    Searchbar,
    Badge,
    AccordionContent,
  } from "framework7-svelte";
  export let f7router;
  export let f7route;
  let user_data = [],
    admin_access_token;
  onMount(() => {
    f7ready(async () => {
      admin_access_token = localStorage.getItem("token");
      await fetch_all_user_details();
    });
  }); 
  const fetch_all_user_details = async () => {
    let obj = new GQLNow(`https://api.trdr.money/graphql/trdr-admin-services`, {
      "x-trdr-org": "60e6cd9df9c32f00072b71f8",
      "x-access-token": admin_access_token,
    });
    try {
      let response = await obj.query(
        "view_request_callback_data",
        { },
        "request_callback_data {name mobile email created_ts}"
      );
      console.log("\n\n Enach Data:", response);
      user_data = response.data.view_request_callback_data.request_callback_data;
      var filtered = user_data.filter(function (el) {
        // return el != null;
        var propNames = Object.getOwnPropertyNames(el);
        for (var i = 0; i < propNames.length; i++) {
          var propName = propNames[i];
          if (el[propName] === null || el[propName] === undefined) {
            el[propName] = "";
          }
        }
      });
      console.log({ user_data });
      //localStorage.setItem("user_data", JSON.stringify(user_data));
    } catch (err) {
      console.log({ gen_otp_error: err });
      f7.dialog.alert(err);
    }
  };

  function user_info(i) {
    f7router.navigate(`/user-full-details/?user=${i}`);
  }

  function convert_date(timestamp) {
    ////console.log("Timestamp", timestamp);
    let t = parseInt(timestamp);
    ////console.log("T:", t);
    var d = new Date(t);
    let final_date =
      d.getDate() +
      "/" +
      (d.getMonth() + 1) +
      "/" +
      d.getFullYear() +
      " " +
      d.getHours() +
      ":" +
      d.getMinutes();

    return final_date;
  }
</script>

<Page class="admin-home">
  <Navbar>
    <NavLeft>
      <Link
        iconIos="f7:menu"
        iconAurora="f7:menu"
        iconMd="material:menu"
        panelOpen="#panel-left"
      />
    </NavLeft>

    <NavRight>
      <Link>
        <p class="title-text">URL:desk.trdr.money</p>
      </Link>
      <Link iconOnly>
        <Icon ios="f7:bell_fill" aurora="f7:bell_fill" md="f7:bell_fill">
          <Badge color="blue">5</Badge>
        </Icon>
      </Link>
      <Link
        iconIos="f7:question_circle"
        iconAurora="f7:question_circle"
        iconMd="f7:question_circle"
      />
      <Link
        iconIos="f7:person_alt_circle"
        iconAurora="f7:person_alt_circle"
        iconMd="f7:person_alt_circle"
      />
      <!-- <Link
        iconIos="f7:menu"
        iconAurora="f7:menu"
        iconMd="material:menu"
        panelOpen="#panel-right"
      /> -->
    </NavRight>

    <!-- <NavTitle>User Details</NavTitle> -->
  </Navbar>
  <!-- Toolbar 
  <Toolbar bottom>
    <Link>Left Link</Link>
    <Link>Right Link</Link>
  </Toolbar> -->
  <!-- Page content 
  <Block strong>
    <p>Here is your blank Framework7 app. Let's see what we have here.</p>
  </Block> -->
  <Panel left cover id="panel-left">
    <Page>
      <BlockTitle>Admin</BlockTitle>
      <List>
        <ListItem panelClose link="/admin-home/" title="Home">
          <i slot="media"> <Icon f7="house" color="black" /></i>
        </ListItem>
        <ListItem panelClose link="" title="Approval">
          <i slot="media"> <Icon f7="briefcase" color="black" /></i>
        </ListItem>
        <ListItem accordionItem title="Users">
          <i slot="media"> <Icon f7="person_crop_rectangle" color="black" /></i>
          <AccordionContent>
            <List>
              <ListItem panelClose link="/users/" title="All Users" />
              <ListItem
                panelClose
                link="/approved-users/"
                title="Approved Users"
              />
              <ListItem
                panelClose
                link="/incomplete-users/"
                title="Incomplete Users"
              />
              <ListItem
                panelClose
                link="/pending-users/"
                title="Pending Users"
              />
            </List>
          </AccordionContent>
        </ListItem>

        <ListItem accordionItem title="ENACH">
          <i slot="media">
            <Icon f7="arrow_clockwise_circle" color="black" /></i
          >
          <AccordionContent>
            <List>
              <ListItem panelClose link="/all-enach/" title="All Enach" />
              <ListItem
                panelClose
                link="/enach-mandate-reg-succ/"
                title="Register Success"
              />
              <ListItem
                panelClose
                link="/enach-mandate-auth-succ/"
                title="Auth Success"
              />
              <ListItem
                panelClose
                link="/enach-mandate-partial/"
                title="Partial"
              />
            </List>
          </AccordionContent>
        </ListItem>

        <ListItem accordionItem title="DEBITS">
          <i slot="media"> <Icon f7="money_dollar_circle" color="black" /></i>
          <AccordionContent>
            <List>
              <ListItem
                panelClose
                link="/enach-debit-all/"
                title="All Debits"
              />
              <ListItem
                panelClose
                link="/enach-debit-success/"
                title="Success Debits"
              />
              <ListItem
                panelClose
                link="/enach-debit-fail/"
                title="Failed Debits"
              />
              <ListItem
                panelClose
                link="/enach-debit-accepted-spo-bank/"
                title="Sponsor Bank Accepted"
              />
              <ListItem
                panelClose
                link="/enach-debit-reject-spo-bank/"
                title="Sponsor Bank Rejected"
              />
              <ListItem
                panelClose
                link="/enach-debit-skipped/"
                title="Skipped Debits"
              />
            </List>
          </AccordionContent>
        </ListItem>
      </List>
    </Page>
  </Panel>

  <div class="page-content padding">
    <BlockTitle large class="padding-left padding-top"
      >Requested Callbacks</BlockTitle
    >
    <Block>
      <div class="card data-table hoverTable">
        <table>
          <thead>
            <tr>
              <th class="label-cell">Name</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {#each user_data as user, i}
              <tr>
                <td>{user.name}</td>
                <td>{user.mobile}</td>
                <td>{user.email}</td>
                <td>{convert_date(user.created_ts)}</td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    </Block>
  </div>
</Page>

<style>
  :global(.demo-card-header-pic .card-header) {
    height: 40vw;
    background-size: cover;
    background-position: center;
    color: #fff;
  }
  :global(.demo-card-header-pic .card-content-padding .date) {
    color: #8e8e93;
  }
  :global(.title-text) {
    position: relative;
    overflow: hidden;
    margin: 0;
    white-space: var(--f7-block-title-white-space);
    text-overflow: ellipsis;
    text-transform: var(--f7-block-title-text-transform);
    color: var(--f7-block-title-text-color);
    font-size: var(--f7-block-title-font-size, inherit);
    font-weight: var(--f7-block-title-font-weight);
    line-height: var(--f7-block-title-line-height);
  }
  .hoverTable {
    width: 100%;
    border-collapse: collapse;
  }
  .hoverTable th {
    background-color: #000;
    color: #fff;
  }
  .hoverTable tr:hover {
    background-color: #000;
    color: #fff;
  }
</style>
